import log from 'log'
import Utilities from '../../../services/commons/Utilities'

export default client => {
  client.interceptors.response.use(response => response, error => {
    const dontLogStatuses = [401, 403, 404, 422, 429]
    if (!dontLogStatuses.includes(error.response.status)) {
      log.error(error)
    }
    if (error.response.status === 422) {
      let errors = []
      for (let key in error.response.data.errors) {
        errors = [...errors, ...error.response.data.errors[key]]
      }
      // var message = error.response.data.message
      // console.log(message + ' - ' + '<br />' + errors.join('<br />'))
      // message += '<br />' + errors.join('<br />')
    }

    if (error.response.status === 401) {
      Utilities.clearDatabase()
    }

    return Promise.reject(error)
  })
}
